import { useMutation } from "@tanstack/react-query";

import { errorMessage, login } from "@/shared/api";
import type { AdminPublic } from "@/shared/api";

/**
 * Вход. Ошибка приводится к тексту здесь, а не в форме: у формы одно поле для
 * сообщения, и разбирать `ApiError` в JSX незачем.
 */
export function useLogin(onSuccess: (admin: AdminPublic) => void) {
  return useMutation({
    mutationFn: login,
    // Обёртка, а не `onSuccess` напрямую: TanStack зовёт колбэк с тремя
    // аргументами (data, variables, context), и вызывающему коду они не нужны
    // — а в тестах лишние аргументы всплывают несовпадением ожиданий.
    onSuccess: (admin) => {
      onSuccess(admin);
    },
  });
}

export { errorMessage };
